export default {
  apiUrl: process.env.VUE_APP_API_URL,
  baseUrl: process.env.VUE_APP_BASE_URL,
  email: 'franziska.weidner@foodtrucksunited.de',
  instagramUrl: 'https://www.instagram.com/foodtrucks_united',
  mapKitJsToken: process.env.VUE_APP_MAP_KIT_JS_TOKEN,
  webUrl: 'https://www.foodtrucksunited.de'
}